import { clsx } from 'clsx'

const CATEGORY_CONFIG = {
  Sunny: {
    bg: 'bg-yellow-500/20',
    text: 'text-yellow-300',
    border: 'border-yellow-500/30',
    icon: '☀️',
  },
  Cloudy: {
    bg: 'bg-slate-500/20',
    text: 'text-slate-300',
    border: 'border-slate-500/30',
    icon: '☁️',
  },
  Foggy: {
    bg: 'bg-gray-500/20',
    text: 'text-gray-300',
    border: 'border-gray-500/30',
    icon: '🌫️',
  },
  Drizzle: {
    bg: 'bg-blue-400/20',
    text: 'text-blue-300',
    border: 'border-blue-400/30',
    icon: '🌦️',
  },
  Rainy: {
    bg: 'bg-blue-600/20',
    text: 'text-blue-200',
    border: 'border-blue-600/30',
    icon: '🌧️',
  },
  Snowy: {
    bg: 'bg-purple-400/20',
    text: 'text-purple-200',
    border: 'border-purple-400/30',
    icon: '❄️',
  },
  Stormy: {
    bg: 'bg-violet-600/20',
    text: 'text-violet-200',
    border: 'border-violet-600/30',
    icon: '⛈️',
  },
  Windy: {
    bg: 'bg-emerald-500/20',
    text: 'text-emerald-300',
    border: 'border-emerald-500/30',
    icon: '💨',
  },
  Unknown: {
    bg: 'bg-slate-700/20',
    text: 'text-slate-400',
    border: 'border-slate-700/30',
    icon: '?',
  },
}

export default function WeatherBadge({ category, size = 'sm', showIcon = true }) {
  const config = CATEGORY_CONFIG[category] ?? CATEGORY_CONFIG.Unknown

  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 rounded-full border font-medium',
        config.bg,
        config.text,
        config.border,
        size === 'sm' && 'px-2 py-0.5 text-xs',
        size === 'md' && 'px-3 py-1 text-sm',
        size === 'lg' && 'px-4 py-1.5 text-base'
      )}
    >
      {showIcon && <span>{config.icon}</span>}
      {category ?? 'Unknown'}
    </span>
  )
}
